import React, { useEffect, useRef } from "react";
import BreadCrumb from "../../../Common/BreadCrumb";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

// onHover
const TooltipButton = ({ content, placement } : any) => {
  const buttonRef: any = useRef();

  useEffect(() => {
    tippy(buttonRef.current, {
      content,
      arrow: true,
      placement,
      trigger: "mouseenter",
      duration: 300,
    });
  }, [content, placement]);

  return (
    <button
      ref={buttonRef}
      type="button"
      className="border rounded-md btn text-purple border-purple hover:bg-purple hover:text-white"
    >
      {content}
    </button>
  );
};

// Animation
const AniTooltipButton = ({content, animation} : any) => {
  const buttonAnimationRef : any = useRef();

  useEffect(() => {
    tippy(buttonAnimationRef.current, {
      content,
      arrow: true,
      animation, // Set the animation type
      duration: 300,
    });
  }, [content, animation]);

  return (
    <button
      ref={buttonAnimationRef}
      type="button"
      className="text-black transition-all duration-300 border rounded-md tippy-tooltip btn border-light hover:bg-light hover:text-black dark:text-white dark:hover:text-black"
    >
      {content}
    </button>
  );
};

// onClick
const MyButton = ({content, placement}: any) => {
  const buttonclickRef : any = useRef();

  useEffect(() => {
    tippy(buttonclickRef.current, {
      content,
      arrow: true,
      placement,
      trigger: 'click',
      duration: 300,
    });
  }, [content, placement]);

  return (
    <button
      ref={buttonclickRef}
      type="button"
      className="transition-all duration-300 border rounded-md tippy-tooltip btn text-purple border-purple hover:bg-purple hover:text-white"
    >
     {content}
    </button>
  );
};


const Tooltips = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Tooltips" pageType="Elements" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Tootlip Basic
            </h2>
            <div className="flex flex-wrap gap-4">
              <TooltipButton content="Tooltip on top" placement="top" />
              <TooltipButton content="Tooltip on right" placement="right" />
              <TooltipButton content="Tooltip on bottom" placement="bottom" />
              <TooltipButton content="Tooltip on left" placement="left" />
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Tootlip animation
            </h2>
            <div className="flex flex-wrap gap-4">
              <AniTooltipButton content="Tooltip animation" animation="scale" />
              <AniTooltipButton content="Tooltip animation" animation="shift-toward" />
              <AniTooltipButton content="Tooltip animation" animation="perspective" />
              <AniTooltipButton content="Tooltip animation" animation="shift-away" />
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Tootlip on click
            </h2>
            <div className="flex flex-wrap gap-4">
              <MyButton content="Tooltip on top" placement="top" />
              <MyButton content="Tooltip on right" placement="right" />
              <MyButton content="Tooltip on bottom" placement="bottom" />
              <MyButton content="Tooltip on left" placement="left" />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Tooltips;
